export const STATIC_FEATURE_TOGGLE_OVERRIDE_SESSION_STORAGE_KEY =
  '@tob/static-feature-toggle-override';
